export default __webpack_public_path__ + "static/media/city.a5a20515.png";